export default "https://cdn-static.gokick.com/assets/b4d66d8cd7eb0aaa0b454a3d41ce872cff261527/images/sleep-tangerine.755ecdb6db700f77bb8084d276871abe.png";